<template>

	<div class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<nav class="navbar navbar-expand-lg">
						<div class="navbar-nav">
							
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 0}" :to="{ name: 'admin-detail' }" v-on:click.native="data.tabActive = 0">
							Detail
							</router-link>
							
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 1}" :to="{ name: 'admin-detail-pelanggan' }" v-on:click.native="data.tabActive = 1">
							Pelanggan
							</router-link>
							
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 2}" :to="{ name: 'admin-detail-pelanggan-belum' }" v-on:click.native="data.tabActive = 2">
							Belum Bayar
							</router-link>
							
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 3}" :to="{ name: 'admin-detail-pelanggan-sudah' }" v-on:click.native="data.tabActive = 3">
							Sudah Bayar
							</router-link>
							
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 3}" :to="{ name: 'admin-detail-pengeluaran' }" v-on:click.native="data.tabActive = 3">
							Pengeluaran
							</router-link>
						</div>
					</nav>
				</div>
			</div>

			<transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
			
		</div>
	</div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
	setup() {
		const data = reactive({
			tabActive: 0,
		})

		return {
			data,
			myGlobal
		}
	},
	mounted () {
		document.title = "Rincian Admin";
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kangtagih/detail.vue